// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1qRVg","column":"style_column__HFnaL","row":"style_row__1rTa5"};